import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import logo from '../../assets/img/nav/logotransparente96x96.webp';
import { menulist } from "../../utils/helper.js";
import './navbar.css'

export default function Navbar() {
    const credentials = useSelector((state) => state.credentials);
    console.log("User from Redux:", credentials);
    
    const [isOpen, setIsOpen] = React.useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const filteredMenu = menulist.filter(item => {
        if (item.id === 'profile') {
            return !!credentials?.token;
        }
        return true;
    });
    
    return (
        <>
            <nav className="navbar navbar-expand-lg justify-content-between fixed-top setting-text">
                <div className="container-fluid">
                    <NavLink to="/" className="navbar-brand brand-nav-text"><img src={logo} alt="NutrioWeb logo" height={'80px'} width={'80px'} />NutrioWeb</NavLink>
                    <button className="navbar-toggler" type="button" onClick={toggleMenu} aria-controls="navbarNav" aria-expanded={isOpen} aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        {
                            filteredMenu.map((item, index) => (
                                <li id={item.id} className="nav-item" key={index} onClick={toggleMenu}>
                                    <NavLink
                                        to={item.path}
                                        className={({ isActive }) => isActive ? 'active' : 'nav-link link'}>
                                        {item.icon}
                                        &nbsp;
                                        {item.id === 'login' && credentials?.token ? "Salir" : item.name}
                                    </NavLink>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </nav >
        </>
    );
}
